var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-switch-phone-3793367",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 57.182,
    viewBox: "0 0 60 57.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M237.589,125.97h-4.084a.544.544,0,0,1,0-1.089h4.084a.544.544,0,0,1,0,1.089Z",
    transform: "translate(-189.207 -121.432)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M217.354,386.4h9.44a.544.544,0,1,1,0,1.089h-9.531a.586.586,0,0,1-.544-.544.663.663,0,0,1,.635-.544Z",
    transform: "translate(-175.779 -340.563)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M168.093,133.553H197.32V107.14a3.544,3.544,0,0,1,3.54-3.54H221.1a3.544,3.544,0,0,1,3.54,3.54v43.2a3.544,3.544,0,0,1-3.54,3.54h-6.172v3.358a3.544,3.544,0,0,1-3.54,3.54h-43.2a3.544,3.544,0,0,1-3.54-3.54v-20.15a3.413,3.413,0,0,1,3.449-3.54Zm54.913,16.792v-43.2a2.015,2.015,0,0,0-2-2H200.769a2.015,2.015,0,0,0-2,2v43.2a2.015,2.015,0,0,0,2,2H221.1a1.939,1.939,0,0,0,1.906-2Zm-56.819,6.9a2.015,2.015,0,0,0,2,2h43.2a2.015,2.015,0,0,0,2-2v-3.358H200.859a3.544,3.544,0,0,1-3.54-3.54V135.1H168.184a2.015,2.015,0,0,0-2,2Z",
    transform: "translate(-164.64 -103.6)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M507.345,356.72a.586.586,0,0,1,.544.544v4.084a.544.544,0,0,1-1.089,0v-4.084A.523.523,0,0,1,507.345,356.72Z",
    transform: "translate(-503.348 -315.694)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M391.082,128.295h0a.766.766,0,0,1-.363.636l-4.084,3.086c-.182.091-.272.182-.454.182a.824.824,0,0,1-.636-.272.753.753,0,0,1,.182-1.089l1-.817a19.857,19.857,0,0,0-8.169,5.537,18.644,18.644,0,0,0-4.176,8.078l.726-1.18a.794.794,0,1,1,1.361.817l-2.632,4.448a.089.089,0,0,1-.091.091l-.181.181a.089.089,0,0,0-.091.091h-.362a.781.781,0,0,1-.726-.726l-1.089-4.811a.749.749,0,0,1,1.452-.363l.182,1a21.363,21.363,0,0,1,4.538-8.623,20.7,20.7,0,0,1,8.623-5.9l-1-.091a.784.784,0,0,1,.272-1.544l5.083.636c.633.545.633.545.633.636Z",
    transform: "translate(-364.575 -123.212)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchPhone);
export default __webpack_public_path__ + "static/media/switch-phone.3351512f925c15019d6b02f226839121.svg";
export { ForwardRef as ReactComponent };